import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const SPORTS = [
  { id: "FOOTBALL", emoji: "⚽", labelKey: "scoring.sport.football", gradient: ["#003a7e", "#002855"], glow: "0, 40, 85" },
  { id: "HOCKEY",   emoji: "🏒", labelKey: "scoring.sport.hockey",   gradient: ["#7ec6f0", "#4DA8DA"], glow: "77, 168, 218" },
];

const SportPicker = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="scoring-pick-row">
      {SPORTS.map((s) => {
        const active = value === s.id;
        return (
          <motion.button
            key={s.id}
            type="button"
            className={`scoring-card scoring-card--sport ${active ? "is-active" : ""}`}
            onClick={() => onChange(s.id)}
            whileHover={{ y: -3 }}
            whileTap={{ scale: 0.97 }}
            style={
              active
                ? {
                    background: `linear-gradient(135deg, ${s.gradient[0]}, ${s.gradient[1]})`,
                    color: "#fff",
                    borderColor: "transparent",
                    boxShadow: `0 0 0 3px rgba(${s.glow}, 0.25), 0 10px 24px rgba(${s.glow}, 0.25)`,
                  }
                : undefined
            }
          >
            <span className="scoring-card__emoji">{s.emoji}</span>
            <span className="scoring-card__label">{t(s.labelKey)}</span>
          </motion.button>
        );
      })}
    </div>
  );
};

export default SportPicker;
